import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";
import { AppErrorBoundary } from "@/components/app-error-boundary";

const SummaryPage = lazy(async () => {
  const m = await import("@/features/gym/components/summary-page");
  return { default: m.SummaryPage };
});

export const summaryRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/summary",
  component: () => (
    <AppErrorBoundary label="stats">
      <Suspense fallback={null}>
        <SummaryPage />
      </Suspense>
    </AppErrorBoundary>
  ),
});
